import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MapPin } from 'lucide-react';
import { DESTINATIONS, TRAVEL_THEMES } from '../../mock';

export function DestinationsGrid() {
  return (
    <section className="max-w-7xl mx-auto px-6 py-20 lg:py-28">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
        <div>
          <div className="text-brand-orange text-[13px] font-semibold tracking-[0.18em] uppercase mb-2">Curated Destinations</div>
          <h2 className="font-poppins text-[34px] lg:text-[44px] text-brand-blue leading-[1.1]">Explore the Himalayas <span className="text-brand-orange">like a local</span></h2>
        </div>
        <p className="text-brand-blue/65 max-w-md text-[15px] leading-relaxed">Hand-picked regions where we have spent years building deep local partnerships - the difference is in the details.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
        {DESTINATIONS.map((d, i) => (
          <Link key={d.slug} to={`/destinations/${d.slug}`} className="group relative rounded-2xl overflow-hidden img-zoom-wrap card-hover bg-brand-blue h-[420px] block animate-fade-up" style={{animationDelay: `${i * 80}ms`}}>
            <img src={d.image} alt={d.name} className="absolute inset-0 w-full h-full object-cover img-zoom opacity-90 group-hover:opacity-100" />
            <div className="absolute inset-0 bg-gradient-to-t from-brand-blue via-brand-blue/40 to-transparent" />
            <div className="relative h-full flex flex-col justify-end p-5 text-white">
              <div className="flex items-center gap-1.5 text-[11px] text-white/75 mb-2">
                <MapPin size={12} /> {d.placesCount} Places · From ₹{d.startingPrice.toLocaleString('en-IN')}
              </div>
              <h3 className="font-poppins font-bold text-[22px] leading-tight">{d.name}</h3>
              <p className="text-white/75 text-[13px] mt-1.5 line-clamp-2">{d.tagline}</p>
              <div className="mt-4 flex items-center gap-2 text-brand-orange font-semibold text-[13px] group-hover:gap-3 transition-all">
                Explore Packages <ArrowRight size={15} />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}

export function ThemesGrid() {
  return (
    <section className="bg-brand-grey py-20 lg:py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <div className="text-brand-orange text-[13px] font-semibold tracking-[0.18em] uppercase mb-2">Travel by Mood</div>
          <h2 className="font-poppins text-[34px] lg:text-[44px] text-brand-blue leading-[1.1]">Find your perfect <span className="text-brand-orange">travel style</span></h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {TRAVEL_THEMES.map((t, i) => (
            <Link key={t.slug} to={`/themes`} className="group relative rounded-xl overflow-hidden img-zoom-wrap h-44 block animate-fade-up" style={{animationDelay: `${i * 60}ms`}}>
              <img src={t.image} alt={t.name} className="absolute inset-0 w-full h-full object-cover img-zoom" />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-blue/90 via-brand-blue/40 to-transparent" />
              <div className="relative h-full flex flex-col justify-end p-3 text-white">
                <h4 className="font-poppins font-semibold text-[14px] leading-tight">{t.name}</h4>
                <div className="text-[10.5px] text-white/75 mt-0.5 line-clamp-1">{t.tagline}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
